/* eslint-disable extra-rules/no-commented-out-code */
import useInjectReducerAndSaga from '@tcp/core/src/utils/useInjectReducerAndSaga';

export default async () => {
  const [AddedToBagReducer, AddedToBagSaga] = await Promise.all([
    import(/* webpackChunkName: "addedToBag" */ './AddedToBag.reducer'),
    import(/* webpackChunkName: "addedToBag" */ './AddedToBag.saga'),
  ]);
  useInjectReducerAndSaga(
    { key: 'AddedToBagReducer', reducer: AddedToBagReducer.default },
    { key: 'AddedToBagSaga', saga: AddedToBagSaga.default }
  );
  return null;
};
